import { AlertBasico, AppDialogToolbar, AppQRCode } from '@/components'
import { SituacaoPreAnalise } from '@/constants'

import { CreditoImobiliarioService, GoAttaService } from '@/services'
import { SHOW_SNACK } from '@/store/MUTATIONS-TYPES'
import { AxiosError } from 'axios'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { VBtn, VCard, VCardActions, VCardText, VDialog, VDivider, VIcon, VRow, VSpacer } from 'vuetify/lib'

export enum TYPE_BUTTON {
	FORM = 1,
	TABLE = 2
}

@Component({})
export class ShareLink extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) showQrCode!: boolean
	@Prop({ type: String, required: false }) url!: string

	isLoading = false
	dialogState = false
	dialog = false
	linkLoading = false
	alert = {
		type: '',
		message: ''
	}

	get isShowQRCode() {
		return this.showQrCode && this.url.length <= 1250
	}

	public render() {
		return <div>{this.renderDialog()}</div>
	}

	renderDialog() {
		return (
			<div>
				{!this.isLoading && (
					<VDialog persistent width="465" vModel={this.dialog}>
						<VCard>
							<AppDialogToolbar vModel={this.dialogState} title="Gerar Link Externo" on={{ 'dialog:close': () => this.closeModal() }} />
							<VCardText class="mt-4">
								{this.isShowQRCode && (
									<div>
										<VRow class="ma-4" align="center" justify="center">
											<AppQRCode ref="qrcode" size={250} parceiroId={1} value={this.url} />
										</VRow>
										<VDivider />
									</div>
								)}
								<AlertBasico outlined type="info" message={this.renderAlert()} />
								<VCardActions>
									<VSpacer />
									<VBtn text color="primary" onClick={() => this.copyLinkText()}>
										<VIcon>link</VIcon> Copiar link
									</VBtn>
									{this.isShowQRCode && (
										<VBtn text color="primary" onClick={() => this.downloadQRCode()}>
											<VIcon>qr_code</VIcon> Download QRCode
										</VBtn>
									)}
								</VCardActions>
							</VCardText>
						</VCard>
					</VDialog>
				)}
			</div>
		)
	}

	renderAlert() {
		return (
			<div>
				<p>O acesso do cliente pode ser feito das seguintes formas:</p>
				<ul>
					{this.isShowQRCode && <li>Imprimir o QR Code e deixar disponível para seus clientes scanear</li>}
					<li>Copie o link e envie por whatsapp</li>
					<li>Copie o link e envie por email</li>
				</ul>
			</div>
		)
	}

	async copyLink() {
		this.linkLoading = true
		try {
			await navigator.clipboard.writeText(this.url)
			if (this.url) this.alert = { type: 'success', message: 'Link copiado com sucesso' }
			this.linkLoading = false
		} catch (err: any | AxiosError) {
			this.alert = { type: 'error', message: err?.response?.data?.message || err?.message }
		}
	}

	closeModal() {
		this.url = ''
		this.alert = { type: '', message: '' }
		this.dialog = false
	}

	refId = 0

	async openModal(url: string, refId?: number) {
		if (refId) this.refId = refId
		if (url) {
			this.url = await GoAttaService.shortUrlLink(url)
		}
		this.dialog = true
	}

	private async copyLinkText() {
		const { commit } = this.$store
		try {
			await navigator.clipboard.writeText(this.url)
			commit(SHOW_SNACK, 'Copiado para área de transferência')
			await this.updatePreAnalysisSituation(this.refId, SituacaoPreAnalise.LINK_ENVIADO)
		} catch (err) {
			console.error('Fallback: Oops, unable to copy', err)
			commit(SHOW_SNACK, 'Não foi possível copiar o link')
		}
	}

	private downloadQRCode() {
		const el = this.$refs['qrcode'] as AppQRCode
		el.download()
	}

	async updatePreAnalysisSituation(refId: number, situation: SituacaoPreAnalise) {
		let status = {
			scoreId: refId,
			situacaoPreAnalise: situation,
			statusPreAnalise: 1
		}
		await CreditoImobiliarioService.updatePreAnalysisSituation(refId, status)
	}
}

export default ShareLink
